import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Transparency = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <rect width="2" height="2" x="1" y="1" fill={color} rx=".5" />
        <rect width="2" height="2" x="5" y="1" fill={color} opacity=".5" rx=".5" />
        <rect width="2" height="2" x="9" y="1" fill={color} opacity=".3" rx=".5" />
        <rect width="2" height="2" x="13" y="1" fill={color} opacity=".1" rx=".5" />
        <rect width="2" height="2" x="3" y="3" fill={color} opacity=".7" rx=".5" />
        <rect width="2" height="2" x="5" y="5" fill={color} opacity=".5" rx=".5" />
        <rect width="2" height="2" x="7" y="3" fill={color} opacity=".4" rx=".5" />
        <rect width="2" height="2" x="11" y="3" fill={color} opacity=".2" rx=".5" />
        <rect width="2" height="2" x="1" y="5" fill={color} rx=".5" />
        <rect width="2" height="2" x="9" y="5" fill={color} opacity=".3" rx=".5" />
        <rect width="2" height="2" x="13" y="5" fill={color} opacity=".1" rx=".5" />
        <rect width="2" height="2" x="3" y="7" fill={color} opacity=".7" rx=".5" />
        <rect width="2" height="2" x="7" y="7" fill={color} opacity=".4" rx=".5" />
        <rect width="2" height="2" x="11" y="7" fill={color} opacity=".2" rx=".5" />
        <rect width="2" height="2" x="5" y="9" fill={color} opacity=".5" rx=".5" />
        <rect width="2" height="2" x="1" y="9" fill={color} rx=".5" />
        <rect width="2" height="2" x="9" y="9" fill={color} opacity=".3" rx=".5" />
        <rect width="2" height="2" x="13" y="9" fill={color} opacity=".1" rx=".5" />
        <rect width="2" height="2" x="5" y="13" fill={color} opacity=".5" rx=".5" />
        <rect width="2" height="2" x="3" y="11" fill={color} opacity=".7" rx=".5" />
        <rect width="2" height="2" x="7" y="11" fill={color} opacity=".4" rx=".5" />
        <rect width="2" height="2" x="11" y="11" fill={color} opacity=".2" rx=".5" />
        <rect width="2" height="2" x="1" y="13" fill={color} rx=".5" />
        <rect width="2" height="2" x="9" y="13" fill={color} opacity=".3" rx=".5" />
        <rect width="2" height="2" x="13" y="13" fill={color} opacity=".1" rx=".5" />
      </svg>
    )
  },
)

export default Transparency
